import axios from "axios";
import { doGet } from "./request";
import store from "../Config/Store";

export default axios.interceptors.response.use(
  (res) => {
    return Promise.resolve(res);
  },
  async (error) => {
    if (error.response.status === 401) {
      const token = JSON.parse(localStorage.getItem("refresh-token"));
      const fmc_token = localStorage.getItem("fmc-token");
      if (error.response.data.error === "TokenExpiredError") {
        try {
          let newTokens;
          if (fmc_token) {
            newTokens = await doGet(
              `/user/refreshToken?token=${token}&fmc_token=${fmc_token}`
            );
          } else {
            newTokens = await doGet(`/user/refreshToken?token=${token}`);
          }
          if (newTokens?.data) {
            localStorage.setItem(
              "refresh-token",
              JSON.stringify(newTokens.data.refreshToken)
            );
            localStorage.setItem(
              "access-token",
              JSON.stringify(newTokens.data.token)
            );
            error.config.headers["access-token"] = newTokens.data.token;
            return axios(error.config);
          }
        } catch (error) {
          localStorage.removeItem("access-token");
          localStorage.removeItem("refresh-token");
          localStorage.removeItem("fmc-token");
          window.location.reload();
        }
      } else if (error.response.data.error === "PasswordOrBasicInfoChanged") {
        const forcedLogout = () => ({
          type: "FORCED_LOGOUT",
        });
        store.dispatch(forcedLogout());
        // localStorage.removeItem("access-token");
        // localStorage.removeItem("refresh-token");
        // localStorage.removeItem("fmc-token");
        // The above commented code now takes place after the popup modal is dismissed in App.js
      }
    } else {
      return Promise.reject(error);
    }
  }
);
